import { registerTidalVersion, validateTidalLicense } from "./base/index.js";
import "./global.d.js";
try {
  const tidalName = "@workwave-tidal/core";
  const tidalVersion = "4.1.0";
  registerTidalVersion(tidalName, tidalVersion);
} catch (_e) {
}
validateTidalLicense();
//# sourceMappingURL=index.js.map
